import React from 'react';
import { Separator } from './ui/Separator';
import { Button } from './ui/Button';
import { Instagram, Facebook, Linkedin, Youtube, ShieldCheck } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0F2440] text-white pt-20 pb-8 font-heading" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-48">
          {/* Column 1: Brand & Social */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-49">
            <img src="https://cdn.magicpatterns.com/uploads/gc9b1jmTiLV6VGgNCyeAdL/IMG_7991-1920w.webp" alt="Busy Drones Cleaners Logo" className="h-20 w-auto object-contain mb-6" data-id="element-50" />
            <p className="text-white/80 italic mb-8 max-w-[250px]" data-id="element-51">
              "If a bee can reach it, then so can we!"
            </p>
            <div className="flex items-center gap-4" data-id="element-52">
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#F5A623] hover:text-[#1B3A5C] transition-colors" aria-label="Instagram" data-id="element-53">
                <Instagram className="w-5 h-5" data-id="element-54" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#F5A623] hover:text-[#1B3A5C] transition-colors" aria-label="Facebook" data-id="element-55">
                <Facebook className="w-5 h-5" data-id="element-56" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#F5A623] hover:text-[#1B3A5C] transition-colors" aria-label="LinkedIn" data-id="element-57">
                <Linkedin className="w-5 h-5" data-id="element-58" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#F5A623] hover:text-[#1B3A5C] transition-colors" aria-label="YouTube" data-id="element-59">
                <Youtube className="w-5 h-5" data-id="element-60" />
              </a>
            </div>
          </div>

          {/* Column 2: Services */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-61">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-62">
              Services
            </h4>
            <ul className="space-y-4" data-id="element-63">
              {['Window Cleaning', 'Pressure & Soft Washing', 'Solar Panel Cleaning', 'Roof Cleaning', 'Surface Cleaning', 'Fleet Cleaning'].map(item => <li key={item} data-id="element-64">
                  <a href="#" className="text-white/70 hover:text-[#F5A623] transition-colors" data-id="element-65">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Company */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-66">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-67">
              Company
            </h4>
            <ul className="space-y-4" data-id="element-68">
              {['About Us', 'Membership', 'FAQs', 'Testimonials', 'Gallery', 'Capabilities'].map(item => <li key={item} data-id="element-69">
                  <a href="#" className="text-white/70 hover:text-[#F5A623] transition-colors" data-id="element-70">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-71">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-72">
              Contact
            </h4>
            <ul className="space-y-4 mb-8" data-id="element-73">
              <li className="text-white/70" data-id="element-74">
                <a href="tel:928-509-0360" className="hover:text-[#F5A623] transition-colors font-bold text-white" data-id="element-75">
                  928-509-0360
                </a>
              </li>
              <li className="text-white/70" data-id="element-76">
                <a href="mailto:john@busydronescleaners.biz" className="hover:text-[#F5A623] transition-colors" data-id="element-77">
                  john@busydronescleaners.biz
                </a>
              </li>
              <li className="text-white/70" data-id="element-78">Yuma, AZ 85365</li>
            </ul>
            <Button className="bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold rounded-md px-8" data-id="element-79">
              Book Now
            </Button>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" data-id="element-80" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/50" data-id="element-81">
          <p data-id="element-82">© 2026 Busy Drones Cleaners LLC. All rights reserved.</p>
          <div className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full border border-white/10" data-id="element-83">
            <ShieldCheck className="w-4 h-4 text-[#F5A623]" data-id="element-84" />
            <span className="font-medium text-white/80" data-id="element-85">
              Veteran-Owned Business
            </span>
          </div>
        </div>
      </div>
    </footer>;
}